
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = true }: CardProps) {
  const hoverClasses = hover ? 'hover:shadow-2xl hover:scale-105 hover:bg-gradient-to-br hover:from-white hover:to-blue-50' : '';
  
  return (
    <div className={`bg-white/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 transition-all duration-300 ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
